let techModeState = $state(false);
let elviePanelState = $state(false);
let sparkDraftState = $state(null);

export const ui = {
  get techMode() { return techModeState; },
  toggleTechMode() { techModeState = !techModeState; },
  get elvieOpen() { return elviePanelState; },
  openElvie() { elviePanelState = true; },
  closeElvie() { elviePanelState = false; },
  toggleElvie() { elviePanelState = !elviePanelState; },
  get sparkDraft() { return sparkDraftState; },
  setSparkDraft(d) { sparkDraftState = d; },
  clearSparkDraft() { sparkDraftState = null; }
};
